<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>超级智能体工作站</el-breadcrumb-item>
        <el-breadcrumb-item>减重智能体</el-breadcrumb-item>
        <el-breadcrumb-item>药物方案</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div style="margin-bottom: 1vh; padding: 0px 0px; border-radius: 4px">
      <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/index' }">&lt;</el-breadcrumb-item> -->
        <i
          class="el-icon-back"
          style="font-size: 20px; font-weight: bolder"
          @click="back()"
        ></i>
      </el-breadcrumb>
    </div>

    <el-button-group>
      <el-button
        class="healthButton"
        @click="click(0)"
        >数字档案
      </el-button>
      <el-button
        class="healthButton"
        @click="click(1)"
        >运动评估
      </el-button>
      <el-button
        class="healthButton"
        @click="click(2)"
        >运动处方</el-button
      >
      <el-button
        class="healthButton"
        @click="click(3)"
        >营养处方</el-button
      >
      <el-button
        class="healthButton"
        @click="click(4)"
        >行为认知治疗</el-button
      >
      <el-button
        class="healthButton healthActive"
        @click="click(5)"
        >药物方案</el-button
      >
      <el-button
        class="healthButton"
        @click="click(6)"
        >临床随访</el-button
      >
    </el-button-group>
    <div class="card-row" style="margin-bottom: 20px">
      <div class="card card01">
        <div
          class="card-row"
          style="font-size: 20px; font-weight: bold; margin-bottom: 2vh"
        >
          {{ info.name }}
        </div>
        <div class="card03" style="font-size: 14px">
          <div>
            性别：{{ info.sex === 1 ? "男" : info.sex === 2 ? "女" : "未填写" }}
          </div>
          <div>手机号码：{{ info.mobile }}</div>
        </div>
        <div class="card03" style="font-size: 14px">
          <div>年龄|生日：{{ info.age }}岁 / 未填写</div>
          <div>
            身高|体重：{{ info.height ? info.height : " " }}cm/{{
              info.weight ? info.weight : " "
            }}kg
          </div>
          <div>身份证号：{{ info.idCard }}</div>
        </div>
      </div>
    </div>

    <div style="margin-top: 50px">
      <div style="font-size: 20px; margin-top: 10px; margin-bottom: 10px">
        药物方案
      </div>
      <avue-crud
        :option="option1"
        :data="drug"
        :page.sync="page1"
        v-model="drugForm"
        :permission="permissionList"
        @row-del="rowDel1"
        @row-update="rowUpdate1"
        @row-save="rowSave1"
        :before-open="beforeOpen1"
        @on-load="onLoad"
        :header-cell-class-name="headerCellClassName"
      >
      </avue-crud>
    </div>
  </basic-container>
</template>

<script>
import { getQa, getUserJkDetail } from "@/api/health/manage";
import { mapGetters } from "vuex";
import {
  getDurg,
  getListUDP,
  getDetailUDP,
  removeUDP,
  submitUDP,
} from "@/api/health/plan_details";
import { getList } from "@/api/health/archiveType";
import func from '@/util/func'

export default {
  data() {
    return {
      wxUserId: this.$route.query.wxUserId,
      info: {},
      form: {},
      form0: {},
      drugForm: {},
      data: [],
      files: [],
      drug: [],
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page1: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option1: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        addBtn: true,
        menuWidth: 200,
        column: [
          {
            type: "tree",
            label: "选择药品 ",
            prop: "ssProvince",
            span: 24,
            hide: true,
            addDisplay: true,
            editDisabled: false,
            dicUrl: "https://dbadmin.dbzdjk.com/admin/fy/rest/third/DmTest",
            dicMethod: "post",
            props: {
              label: "name",
              value: "code",
            },
            slot: true,
            nodeClick: (data) => {
              getDurg(data.code).then((res) => {
                const data1 = res.data;
                this.drugForm.drugName = data1.drugName;
                this.drugForm.tradeName = data1.tradeName;
                this.drugForm.indications = data1.indications;
                this.drugForm.dosageTaken = data1.dosageTaken;
                this.drugForm.medicationFrequency = data1.medicationFrequency;
                this.drugForm.medicationTime = data1.medicationTime;
                this.drugForm.note = data1.note;
              });
            },
          },
          {
            label: "药品名称",
            prop: "drugName",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入药品名称",
              },
            ],
          },
          {
            label: "商品名称",
            prop: "tradeName",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入商品名称",
              },
            ],
          },
          {
            label: "适用症状",
            prop: "indications",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入药品名称",
              },
            ],
          },
          {
            label: "服用剂量",
            prop: "dosageTaken",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入服用剂量",
              },
            ],
          },
          {
            label: "服用频次",
            prop: "medicationFrequency",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入服用频次",
              },
            ],
          },
          {
            label: "服用时间",
            prop: "medicationTime",
            span: 24,
            cell: true,
            rules: [
              {
                required: true,
                message: "请输入服用时间",
              },
            ],
          },
          {
            label: "注意事项",
            prop: "note",
            span: 24,
            cell: true,
            rules: [
              {
                required: false,
                message: "请输入注意事项",
              },
            ],
          },
          {
            label: "创建时间",
            prop: "createTime",
            addDisplay: false,
            editDisabled: true,
            span: 24,
            hide: true,
            cell: false,
          },
          {
            label: "修改时间",
            prop: "updateTime",
            addDisplay: false,
            editDisabled: true,
            span: 24,
            hide: true,
            cell: false,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.qa_qa_add,
        viewBtn: this.permission.qa_qa_view,
        delBtn: this.permission.qa_qa_delete,
        editBtn: this.permission.qa_qa_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  created() {
    this.wxUserId = this.$route.query.wxUserId;
  },
  methods: {
    onLoad(page, params = { id: this.wxUserId }) {
      const wxUserId = this.$route.query.wxUserId;

      getUserJkDetail(wxUserId).then((res) => {
        const wxUserId = window.localStorage.getItem('pcUserId');
        if (wxUserId === '2043870969731301377') {
          res.data.userJk.name = func.maskName(res.data.userJk.name);
          res.data.userJk.mobile = func.maskPhone(res.data.userJk.mobile);
        }
        this.info = res.data.userJk;
      });

      getQa(wxUserId).then((res) => {
        console.log("getQa?", res.data);
        this.data = res.data;
      });
      // getDigitalArchives(wxUserId).then((res) => {
      //   this.data = res.data;
      // });
      getList(page.currentPage, page.pageSize, params).then((res) => {
        console.log(res.data);
        this.files = res.data;
      });
      getListUDP(this.wxUserId).then((res) => {
        const data1 = res.data.records;
        this.page2.total1 = data1.total;
        this.drug = data1;
      });
    },

    toItemModify(row) {
      this.$router.push({
        path: "/doctor/archiveTypeDetails",
        query: {
          wxUserId: this.wxUserId,
          type: row.type,
        },
      });
    },

    toItemModify2(row) {
      this.$router.push({
        path: "/doctor/questionnaire",
        query: {
          wxUserId: this.wxUserId,
          qaId: row.id,
          qaName: row.name,
        },
      });
    },

    beforeOpen1(done, type) {
      console.log(this.drugForm);
      if (["edit", "view"].includes(type)) {
        getDetailUDP(this.drugForm.id).then((res) => {
          this.drugForm = res.data;
        });
      }
      done();
    },

    rowSave1(row, done, loading) {
      row.isUsing = "1";
      row.wxUserId = this.wxUserId;
      submitUDP(row)
        .then(() => {
          done();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },

    rowUpdate1(row, index, done, loading) {
      row.wxUserId = this.wxUserId;
      submitUDP(row)
        .then(() => {
          done();
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        })
        .catch(() => {
          loading();
        });
    },

    rowDel1(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return removeUDP(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
        });
    },

    click(index) {
      let path = "";
      switch (index) {
        case 0:
          // path = "/agent/digitalarchive";
                    path = '/agent/dataarchive'
          break;
        case 1:
          path = "/agent/lossWeightBodyData";
          break;
        case 2:
          path = "/agent/homeMotion";
          break;
        case 3:
          path = "/agent/lossWeightClinicalExercise";
          break;
        case 4:
          path = "/agent/lossWeightCognitivebehaviorald";
          break;
        case 5:
          path = "/agent/lossWeightDrug";
          break;
        case 6:
          path = "/agent/lossWeightFollow";
          break;
      }
      const parameter = {
        wxUserId: this.wxUserId,
      };
      this.$router.push({
        path: path,
        query: parameter,
      });
    },

    back() {
      // this.$router.go(-1);
      this.$router.push({
        path: "/agent/weightLoss",
      });
    },
  },
};
</script>

<style scoped>
.card-row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1vh;
  gap: 10px;
}

.card {
  background: rgba(243, 235, 235, 0.884) 2F5;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 1vw;
  box-sizing: border-box;
}

.card01 {
  flex: 1;
  height: auto;
}

.card03 {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 2vh;
}

.healthButton {
  /* background-color: #ebedf0; */
  color: black;
  border: 0px solid #c1c3c5;
  border-bottom: none;
  font-size: 15px;
  border-radius: 0px;
  margin-bottom:2px;
}
.healthActive{
  border-bottom:3px solid #409EFF;
  color:#409EFF;
  font-weight: bold;
}
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>

